import React, { useState, useEffect } from "react";
import { useFormik } from 'formik';
import axios from 'axios';
import { BASE_URL, UPLOAD_IMG, POST_GENERAL_SETTINGS } from '../utlilities/config'; 
import { ToastContainer, toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getWebUserInfo, initializeWebUserInfo } from "../utlilities/webConfig";
import { FiImage, FiUpload, FiTrash2, FiSave } from 'react-icons/fi';

const ReceptionDetails = () => {
    const [loading, setLoading] = useState(false);
    const [headerImage, setHeaderImage] = useState(null);
    const [footerImage, setFooterImage] = useState(null);
    const [selectedHeader, setSelectedHeader] = useState(null);
    const [selectedFooter, setSelectedFooter] = useState(null);
    const [headerImageUrl, setHeaderImageUrl] = useState(null);
    const [footerImageUrl, setFooterImageUrl] = useState(null);
    const [generalopSettings, setGeneralopSettings] = useState({});
    const [generalSettings, setGeneralSettings] = useState({});

    const token = localStorage.getItem('accessToken');
    
    var headerImageCloudUrl = '';
    var footerImageCloudUrl = '';

    const isElectron = () => {
      return window && window.process && window.process.type;
    };
  
    let ipcRenderer;
  
    if (isElectron()) {
        ipcRenderer = window.require('electron').ipcRenderer;
    }
  
    useEffect(() => {
      const fetchData = async () => {
        let settings;
        let settings1;
  
        if (isElectron()) {

          settings = await ipcRenderer.invoke('store-get', 'generalopsettings');
          setGeneralopSettings(settings || {});

          settings1 = await ipcRenderer.invoke('store-get', 'generalsettings');
          setGeneralSettings(settings1 || {});

          setSelectedHeader(settings?.OpHeaderImageUrl);
          setSelectedFooter(settings?.OpFooterImageUrl);
          setHeaderImageUrl(settings?.OpHeaderImageUrl);
          setFooterImageUrl(settings?.OpFooterImageUrl);
        } else {
            initializeWebUserInfo();

            settings = getWebUserInfo().generalopsettings; // Fetch from webConfig
            setGeneralopSettings(settings || {});

            settings1 = getWebUserInfo().generalSettings;
            setGeneralSettings(settings1 || {});

            setSelectedHeader(settings?.OpHeaderImageUrl);
            setSelectedFooter(settings?.OpFooterImageUrl);
            setHeaderImageUrl(settings?.OpHeaderImageUrl);
            setFooterImageUrl(settings?.OpFooterImageUrl);
        }
      };
  
      fetchData();
    }, []);
    
    const formik = useFormik({
      initialValues: {
        headerImage: headerImage,
        footerImage: footerImage,
      },
      onSubmit: async (values, { setSubmitting, resetForm }) => {
        try {
          setLoading(true);
          let headerImageUrlLocal = headerImageUrl;
          let footerImageUrlLocal = footerImageUrl;
    
          if (headerImage) {
            const headerFormData = new FormData();
            headerFormData.append('file', headerImage);
    
            const headerResponse = await axios.post(`${BASE_URL}${UPLOAD_IMG}`, headerFormData, {
              headers: {
                'XApiKey': process.env.REACT_APP_API_KEY,
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${token}`,
              },
            });
    
            if (headerResponse.status === 200) {
              headerImageUrlLocal = headerResponse.data.url;
              headerImageCloudUrl = headerResponse.data.cloudUrl;
            } else {
              throw new Error('Failed to upload header image');
            }
          }
    
          if (footerImage) {
            const footerFormData = new FormData();
            footerFormData.append('file', footerImage);
    
            const footerResponse = await axios.post(`${BASE_URL}${UPLOAD_IMG}`, footerFormData, {
              headers: {
                'XApiKey': process.env.REACT_APP_API_KEY,
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${token}`,
              },
            });
    
            if (footerResponse.status === 200) {
              footerImageUrlLocal = footerResponse.data.url;
              footerImageCloudUrl = footerResponse.data.cloudUrl;
            } else {
              throw new Error('Failed to upload footer image');
            }
          }

          const data = {
            ClientID: generalSettings?.ClientID || '',
            AddressLine1: generalopSettings.AddressLine1,
            AddressLine2: generalopSettings.AddressLine2,
            FirstName: generalopSettings.FirstName,
            LastName: generalopSettings.LastName,
            GstNo: generalopSettings.GstNo,
            MobileNo1: generalopSettings.MobileNo1,
            MobileNo2: generalopSettings.MobileNo2,
            Place: generalopSettings.Place,
            ShowQRonBill: generalopSettings.ShowQRonBill,
            WorkingTime: generalopSettings.WorkingTime,
            OpcardTopMargin: generalopSettings.OpcardTopMargin,
            OpcardBottomMargin: generalopSettings.OpcardBottomMargin,
            OpcardLeftMargin: generalopSettings.OpcardRightMargin,
            OpcardRightMargin: generalopSettings.OpcardLeftMargin,
            vitalsRightmargin: generalopSettings.vitalsRightmargin,
            showVitals: generalopSettings.showVitals,
            opcardTopborder: generalopSettings.opcardTopborder,
            opcardBottomborder: generalopSettings.opcardBottomborder,
            AutoBillPrint: generalopSettings.AutoBillPrint,
            AutoRecieptPrint: generalopSettings.AutoRecieptPrint,
            AutoOpcardPrint: generalopSettings.AutoOpcardPrint,
            BillTemplate: generalopSettings.BillTemplate,
            OpcardTemplate: generalopSettings.OpcardTemplate,
            BillType: generalopSettings.BillType,
            OpcardType: generalopSettings.OpcardType,
            RecieptType: generalopSettings.RecieptType,
            RecieptTemplate: generalopSettings.RecieptTemplate,
            paymentMarkOnOpSave: generalopSettings.paymentMarkOnOpSave,
            paymentMarkOnBillSave: generalopSettings.paymentMarkOnBillSave,
            ShowFirmname: generalopSettings.ShowFirmname,
            ShowFirmnumber: generalopSettings.ShowFirmnumber,
            ShowAddress : generalopSettings.ShowAddress,
            ShowGst: generalopSettings.ShowGst,
            ShowWorkingHourse: generalopSettings.ShowWorkingHourse,
            ShowUsername : generalopSettings.ShowUsername,
            ShowToken: generalSettings.ShowToken,

            OpHeaderImageUrl: headerImageUrlLocal,
            OpFooterImageUrl: footerImageUrlLocal,
            OpHeaderCloudImageUrl: headerImageCloudUrl,
            OpFooterCloudImageUrl: footerImageCloudUrl,


          
          };

          const updatedGeneralSettings = {
            ...generalSettings,
            ReceptionSettings: [data]
          };

  
          const response = await axios.post(`${BASE_URL}${POST_GENERAL_SETTINGS}`, updatedGeneralSettings, {
            headers: {
              'XApiKey': process.env.REACT_APP_API_KEY,
              'Authorization': `Bearer ${token}`,
            },
          });

          if(response.status === 200) {
            toast.success('Settings saved successfully!', {
              autoClose: 1000,
              icon: '✅',
            });

            // const settings = {
            //   ...generalopSettings,
            //   ...data
            // };

            // console.log('hereeee', settings)
            
            if(isElectron()) {
              await ipcRenderer.invoke('store-set', 'generalopsettings', data);
            }
            resetForm();
          } else {
            throw new Error('Failed to submit final data');
          }
    
        } catch (error) {
          setLoading(false);
          toast.error(error.response?.data?.message || 'An error occurred', {
            autoClose: 1000,
          });
          console.log(error);
        } finally {
          setLoading(false);
          setSubmitting(false);
        }
      },
    });
    
    const handleInputImage = (event, type) => {
      if (event.target.files && event.target.files[0]) {
          const imageUrl = URL.createObjectURL(event.target.files[0]);
          if (type === 'header') {
              setSelectedHeader(imageUrl);
              setHeaderImage(event.target.files[0]);
          } else if (type === 'footer') {
              setSelectedFooter(imageUrl);
              setFooterImage(event.target.files[0]);
          }
      }
    };

    const removeHeader = () => {
      setSelectedHeader(null);
      setHeaderImageUrl(null);
    };

    const removeFooter = () => {
      setSelectedFooter(null);
      setFooterImageUrl(null);
    };

    // Loading overlay component
    const LoadingOverlay = () => (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-white bg-opacity-80 backdrop-blur-sm">
        <div className="flex flex-col items-center gap-3">
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-indigo-600"></div>
          <p className="text-indigo-600 font-medium">Saving images...</p>
        </div>
      </div>
    );

    // Image card component
    const ImageCard = ({ title, image, onChange, onRemove, inputId }) => (
      <div className="bg-white rounded-xl shadow-sm p-6 flex flex-col h-full">
        <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
          <FiImage className="mr-2 text-indigo-500" />
          {title}
        </h3>
        
        <div className="flex-grow flex items-center justify-center bg-gray-50 rounded-lg p-4 mb-4 border-2 border-dashed border-gray-200">
          {image ? (
            <img 
              src={image} 
              alt={`${title} Preview`} 
              className="max-h-48 max-w-full object-contain rounded"
            />
          ) : (
            <div className="flex flex-col items-center justify-center text-gray-400 p-6">
              <FiImage size={48} className="mb-2" />
              <p className="text-sm text-center">No image selected</p>
            </div>
          )}
        </div>
        
        <div className="flex space-x-3 mt-2">
          <label 
            htmlFor={inputId} 
            className="flex items-center justify-center px-4 py-2 bg-indigo-50 text-indigo-600 rounded-lg hover:bg-indigo-100 transition-colors cursor-pointer flex-1"
          >
            <FiUpload className="mr-2" />
            Change
          </label>
          <input
            type="file"
            id={inputId}
            accept="image/*"
            className="hidden"
            onChange={onChange}
          />
          <button 
            onClick={onRemove} 
            className="flex items-center justify-center px-4 py-2 bg-red-50 text-red-600 rounded-lg hover:bg-red-100 transition-colors flex-1"
          >
            <FiTrash2 className="mr-2" />
            Remove
          </button>
        </div>
      </div>
    );

    return (
      <div className="p-6">
        <ToastContainer
          position="top-center"
          autoClose={1000}
          limit={1}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          transition={Slide}
        />
        
        {loading && <LoadingOverlay />}
        
        <form onSubmit={formik.handleSubmit} className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <ImageCard 
              title="Header Image"
              image={selectedHeader}
              onChange={(e) => handleInputImage(e, 'header')}
              onRemove={removeHeader}
              inputId="header-upload"
            />
            
            <ImageCard 
              title="Footer Image"
              image={selectedFooter}
              onChange={(e) => handleInputImage(e, 'footer')}
              onRemove={removeFooter}
              inputId="footer-upload"
            />
          </div>
          
          <div className="flex justify-end">
            <button 
              type="submit" 
              disabled={loading}
              className="flex items-center px-6 py-3 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-medium rounded-lg shadow hover:from-indigo-700 hover:to-purple-700 transition-all duration-200"
            >
              <FiSave className="mr-2" />
              Save Images
            </button>
          </div>
        </form>
      </div>
    );
};

export default ReceptionDetails;